import React from 'react';
import { Shield, UserCheck, Zap, MessageCircle, MapPin, TrendingUp } from 'lucide-react';
import './WhyUs.css';

const reasonsData = [
  {
    icon: <Shield size={32} />,
    title: 'White-Label & NDA Friendly',
    description: 'Complete confidentiality and work under your brand'
  },
  {
    icon: <UserCheck size={32} />,
    title: 'Direct Access to Senior Developer',
    description: '7+ years experience, no middlemen or juniors'
  },
  {
    icon: <Zap size={32} />,
    title: 'No Hiring Risk, Flexible Engagement',
    description: 'Scale up or down based on your project needs'
  },
  {
    icon: <MessageCircle size={32} />,
    title: 'Fast Turnaround & Clear Communication',
    description: 'Weekly updates, transparent progress tracking'
  },
  {
    icon: <MapPin size={32} />,
    title: 'Local Trust + Remote Delivery',
    description: 'Available for in-person meetings in India'
  },
  {
    icon: <TrendingUp size={32} />,
    title: 'Scalable from Small Tasks to Full Partnerships',
    description: 'Start small, grow into long-term collaboration'
  }
];

const WhyUs = () => {
  return (
    <section className="why-us-section">
      <div className="why-us-container">
        <div className="why-us-header">
          <h2 className="section-title">Why Agencies Choose Us</h2>
          <p className="section-description">
            Trusted partner for scalable, reliable white-label Laravel development
          </p>
        </div>
        
        <div className="reasons-grid">
          {reasonsData.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-icon">{reason.icon}</div>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;